import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import _ from "lodash";
import ReactMapboxGl from "react-mapbox-gl";

import useInterval from "../../../hooks/useInterval";
import { entitySelector, fetchEntities } from "../../shared/entity/slice";
import Spinner from "../../../components/Spinner";
import MonitoringView from "./view";

const Map = ReactMapboxGl({
    accessToken:
        "pk.eyJ1IjoiZGVhZGxvY2siLCJhIjoiY2o4b25pY3dqMDU5bjJ3cWNoNWMzZ2QwciJ9.bsjPa7Or0YmYeXXI1EHFUA",
});

export default function MonitoringContainer() {
    const [pageIndex, setPageIndex] = useState(0);
    const drivers = useSelector(entitySelector("drivers"));

    const dispatch = useDispatch();

    useInterval(() => {
        fetchDrivers();
    }, 15000);

    useEffect(() => {
        fetchDrivers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageIndex]);

    function goToPage(index) {
        setPageIndex(index);
    }

    function fetchDrivers() {
        dispatch(fetchEntities("drivers", pageIndex, null, "isOnline", "desc", ""));
    }

    return !drivers.data ? (
        <Spinner />
    ) : (
        <MonitoringView
            drivers={_.map(drivers.data, (d) => ({ id: d.id, ...d.attributes }))}
            Map={Map}
            pageIndex={pageIndex}
            pageCount={drivers.meta.pageCount}
            goToPage={goToPage}
            totalDriversCount={drivers.meta.totalRecordCount}
        />
    );
}
